import React, { useEffect, useRef } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { SideBarItemContainer } from '../../styles'; 
import { scrollDown } from 'utils/scrollDown';

const CustomGroupRenderer = ({ group }) => {

  const location = useLocation();
  const roomRef = useRef();

  // Scroll to room on first render
  useEffect(() => {
    if (roomRef.current) scrollDown(roomRef.current?.offsetTop, 1000);
  }, []);

  const isOutOfOrder = group.status === 'OUT_OF_ORDER';

  return (
    <SideBarItemContainer
      key={group.id}
      warning={isOutOfOrder}
      ref={group.id === location.state?.roomNumber ? roomRef : null}
    >
      <Link
        className="groupName"
        to={`/room-details/${group.id}`}
      >
        {group.id}
      </Link>
      {isOutOfOrder && <span className="warningCover"></span>}
    </SideBarItemContainer>
  );
};

export default CustomGroupRenderer;